<div>
    <h5>{{title}}</h5>

    <!-- The tables for Strata and Non-Strata dependencies use static and flexible column width respectively, hence the odd configuration. -->
    <!-- FIXME: This quirk could be more easily avoided if 'conversion number' was no longer its own column, -->
    <!--  rather with the input field being moved under the action, as per 'treatment action' -->

    <div [ngClass]="{'row': dependencyType === 'STRATA'}">
        <div [ngClass]="{'col-xs-12': dependencyType === 'STRATA'}">
            <table class="table table-hover table-striped">
                <thead>
                    <tr class="default">
                        <td
                            class="col-header-no-wrap"
                            [ngClass]="{'col-md-2': dependencyType === 'STRATA'}"
                            title="The plan type and plan number of the dependent plan">
                            Plan
                        </td>

                        @if (doDisplay('tenure')) {
                            <td
                                class="col-header-no-wrap"
                                [ngClass]="{'col-md-2': dependencyType === 'STRATA'}"
                                title="The tenure type of the dependent plan">
                                Tenure
                            </td>
                        }

                        <td
                            class="col-header-no-wrap"
                            [ngClass]="{'col-md-3': dependencyType === 'STRATA'}"
                            title="The plan purpose of the dependent plan">
                            Purpose
                        </td>

                        <td
                            [ngClass]="{'col-md-2': dependencyType === 'STRATA'}"
                            title="The description of the dependent plan">
                            Description
                        </td>

                        @if (doDisplay('parentPlan')) {
                            <td
                                [ngClass]="{'col-md-2': dependencyType === 'STRATA'}"
                                title="The description of the dependent plan">
                                Parent Plan
                            </td>
                        }

                        <!-- This column always has a static width, but this is applied with different CSS classes between Strata and Non-Strata -->
                        <td
                            class="col-md-2 col-header-no-wrap"
                            title="The proposed action required of the dependent plan">
                            Action
                        </td>

                        @if (doDisplay('conversionNumber')) {
                            <td
                                class="col-header-no-wrap"
                                [ngClass]="{'col-md-3': dependencyType === 'STRATA'}"
                                title="The conversion DP for the termination of the dependent strata plan">
                            </td>
                        }

                        <td
                            class="col-header-no-wrap dependent-plan-action-status"
                            title="Action status">
                            &nbsp;
                        </td>
                    </tr>
                </thead>

                <tbody>
                    @for (dependentPlan of applicableDependentPlans(); track dependentPlan; let i = $index) {
                        <tr>
                            <td
                                class="text-left"
                                title="{{title}}"
                                >{{dependentPlan.dependentPlanText || '&nbsp;'}}</td
                            >
                            @if (doDisplay('tenure')) {
                                <td
                                    class="text-left"
                                    title="{{title}}">
                                    {{dependentPlan.tenureType.name || '&nbsp;'}}
                                </td>
                            }
                            <td
                                class="text-left"
                                title="{{title}}"
                                >{{dependentPlan.planPurpose.name || '&nbsp;'}}</td
                            >
                            <td
                                class="text-left"
                                title="{{title}}"
                                >{{dependentPlan.planHeading || '&nbsp;'}}</td
                            >
                            @if (doDisplay('parentPlan')) {
                                <td
                                    class="text-left"
                                    title="{{title}}">
                                    {{dependentPlan.parentPlan || '&nbsp;'}}
                                </td>
                            }
                            <td class="text-left">
                                <div
                                    class="input-group"
                                    [hidden]="!dependantPlansActionsAvailable(dependentPlan)">
                                    <ng-select
                                        class="nlr-ng-select"
                                        [searchable]="false"
                                        [clearable]="false"
                                        [disabled]="isActionDisabled()"
                                        [name]="dependencyType + 'DependentPlanAction' + i"
                                        [id]="dependencyType + 'DependentPlanAction' + i"
                                        [ngClass]="{'has-error': dependentPlanAction | formFieldHasError}"
                                        placeholder="Select action"
                                        [items]="getDependentPlanActionIds(dependentPlan)"
                                        [trackByFn]="dependentPlanActionIdTrackBy"
                                        (change)="onActionChange(dependentPlan, dependencyType, i)"
                                        [(ngModel)]="dependentPlan.action"
                                        #dependentPlanAction="ngModel"
                                        required>
                                        <ng-template
                                            ng-label-tmp
                                            let-item="item">
                                            {{ actionNameFromId(item) }}
                                        </ng-template>
                                        <ng-template
                                            ng-option-tmp
                                            let-item="item">
                                            {{ actionNameFromId(item) }}
                                        </ng-template>
                                    </ng-select>
                                </div>
                                @if (expectTreatmentDetails(dependentPlan)) {
                                    <div [ngClass]="{'has-error': treatmentDetails | formFieldHasError}">
                                        <textarea
                                            title="Enter nature of modification"
                                            placeholder="Enter nature of modification"
                                            class="form-control"
                                            rows="5"
                                            cols="60"
                                            required
                                            [attr.name]="dependencyType + 'treatmentDetails' + i"
                                            [name]="dependencyType + 'treatmentDetails' + i"
                                            [maxlength]="250"
                                            [disabled]="treatmentDetailsDisabled()"
                                            (change)="onTreatMentDetailsChange(dependentPlan, dependencyType, i)"
                                            [(ngModel)]="dependentPlan.treatmentDetails"
                                            #treatmentDetails="ngModel">
                                        </textarea>
                                    </div>
                                }
                                @if (isStrataDependency(dependentPlan) && !dependantPlansActionsAvailable(dependentPlan)) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{getErrorMessageIfNoDependentStrataActions()}}</span>
                                    </div>
                                }
                            </td>
                            @if (doDisplay('conversionNumber')) {
                                <td class="text-left">
                                    @if (expectConversionNumber(dependentPlan)) {
                                        <div
                                            class="input-group"
                                            [ngClass]="{'has-error': strataPlanConversionNumber.invalid && strataPlanConversionNumber.dirty}">
                                            <span class="input-group-addon">
                                                <i class="nlrp-icon nlrp-icon-edit"></i>
                                            </span>
                                            <input
                                                type="number"
                                                class="form-control"
                                                min="0"
                                                max="999999"
                                                maxlength-input-limit="6"
                                                [attr.placeholder]="conversionPlanPlaceholderFromActionId(dependentPlan.action)"
                                                [attr.name]="'strataPlanConversionDP' + i"
                                                [name]="'strataPlanConversionDP' + i"
                                                [title]="conversionPlanTooltipFromActionId(dependentPlan.action)"
                                                [disabled]="conversionNumberDisabled()"
                                                [(ngModel)]="dependentPlan.conversionPlanNumber"
                                                #strataPlanConversionNumber="ngModel" />
                                        </div>
                                    }
                                </td>
                            }
                            <td
                                class="text-left actions"
                                style="width: 40px">
                                <i
                                    class="nlrp-icon"
                                    [ngClass]="isActionValid(dependentPlan) ? 'nlrp-icon-verified-passed active' : 'nlrp-icon-error error'"
                                    [title]="actionValidityTooltip(dependentPlan)"
                                    aria-hidden="true">
                                </i>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

@if (invalidFormerTenureText) {
    <div class="help-block">
        <span>Error!</span>
        <span>
            {{invalidFormerTenureText}}
        </span>
    </div>
}
